import React from "react";
import { Link } from "react-router-dom";
import HeroIllustration from "../assets/hero-illustration.svg";

const Hero = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: Text Content */}
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight tracking-tight mb-6">
            Building Scalable &<br className="hidden md:block" />
            Modern Software Solutions
          </h1>
          <p className="text-lg text-gray-500 mb-8 leading-relaxed">
            We partner with businesses to design and develop custom web and mobile applications that are fast, reliable, and future-proof.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#4C47DC] text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-[#3c38c0] hover:scale-105 transition-transform duration-200 shadow-md"
          >
            Let's Talk
          </Link>
        </div>

        {/* Right: Illustration */}
        <div className="hidden md:block">
          <img
            src={HeroIllustration}
            alt="Development Illustration"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
